import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'


type OrderInfoContainerProps = {
  className?: string
}

const OrderItemsContainer: React.CFC<OrderInfoContainerProps> = (props) => {
  const { children, className } = props
  const { isMobile } = useDevice()

  return (
    <div className={cx(className, !isMobile && 'w-full bg-white border-gray-30 radius-5 p-40')}>
      {children}
    </div>
  )
}


export default OrderItemsContainer
